import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  getBtnProps,
  TransitionBtn,
  useGetBrokerMaster,
  useIsPrevPageConfirmStore,
  reloadHandler,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  depositAccountInfoOnSubmit,
  depositAccountInfoInitialValues,
  DepositAccountFormikType,
  depositAccountInfoValidation,
  AccountEstablishRequestParam,
  formErrorScroll,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'react-use';

export const useDepositAccountInfo = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();
  const { isPrevPageConfirm, setIsPrevPageConfirm } = useIsPrevPageConfirmStore();
  const { param, add } = useEstablishStore();
  const initialValues = depositAccountInfoInitialValues(param);
  const onSubmit = depositAccountInfoOnSubmit<AccountEstablishRequestParam>(param, add, () =>
    setNowEstablishPageType(isPrevPageConfirm ? EstablishPageType.RequestConfirm : EstablishPageType.Employment),
  );

  const formik: DepositAccountFormikType = useFormik({
    initialValues,
    validationSchema: depositAccountInfoValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const [isNextBtnDisabled, setIsNextBtnDisabled] = useState(false);
  const nextButtonProps: ButtonProps = { ...getBtnProps(TransitionBtn.NEXT), disabled: isNextBtnDisabled };
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () =>
    setNowEstablishPageType(EstablishPageType.CustomerInfo),
  );
  const confirmButtonProps: ButtonProps = getBtnProps(TransitionBtn.CONFIRM);

  useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.DepositAccount) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  useEffect(() => {
    if (isEmpty(formik.errors)) return;
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
      confirmButtonProps,
      isPrevPageConfirm,
    },
  };
};
